import React, { useState } from "react";
import { Confirm, Icon, Form, Radio } from "semantic-ui-react";

export const CURRENT_INVOICE = "CURRENT_INVOICE";
export const ALL_INVOICES = "ALL_INVOICES"; 


const CopyRepElement = (props) => {

    const { 
        translate, 
        title, 
        request, 
        callback, 
        isFormDisabled, 
        tableName='', 
        extraCallback=()=>{}
    } = props

    const [state, setState] = useState({ open: false, copyRepElemFor: '', error: '' })
    const open = () => {
        extraCallback()
        setState(preState => ({ ...preState, open: true }))
    }

    const close = () => {
        extraCallback()
        setState({ open: false, copyRepElemFor: '', error: '' })
    }
    const handleChange = (value) => setState(preState => ({ ...preState, copyRepElemFor: value, error: '' }))
    const handleConfirm = () => {
        if (!state?.copyRepElemFor)
            setState(preState => ({
                ...preState,
                error: 'Required*'
            }))
        else {
            const option = state?.copyRepElemFor == CURRENT_INVOICE ? CURRENT_INVOICE : ALL_INVOICES
            callback(option, request, tableName)
            close()
        }
    };

    return (
        <span>
            <Icon
                name='copy outline'
                size='large'
                style={{ margin: '10px 5px', cursor: 'pointer' }}
                onClick={open}
                disabled={isFormDisabled}
            />
            <Confirm
                open={state?.open}
                onCancel={close}
                header={translate('COPY_REP_ELEM', { ns: ['default', 'lineItem'], title: translate(title, { ns: ['default', 'lineItem'] }) })}
                content={<CopyOptions
                    translate={translate}
                    state={state}
                    handleChange={handleChange}
                />}
                confirmButton={translate('COPY')}
                cancelButton={translate('CANCEL')}
                size='tiny'
                onConfirm={handleConfirm}
            />
        </span>
    )
}

const CopyOptions = ({ translate, state, handleChange }) => {

    return (
        <div style={{ margin: "20px" }}>
            <Form>
                <Form.Field>
                    <Radio
                        label={translate('CURRENT_INVOICE', { ns: ['default', 'lineItem'] })}
                        name="radioGroup"
                        value={CURRENT_INVOICE}
                        checked={state?.copyRepElemFor === CURRENT_INVOICE}
                        onChange={(e, { value }) => handleChange(value)}
                    />
                </Form.Field>
                <Form.Field>
                    <Radio
                        label={translate('ALL_INVOICES', { ns: ['default', 'lineItem'] })}
                        name="radioGroup"
                        value={ALL_INVOICES}
                        checked={state?.copyRepElemFor === ALL_INVOICES}
                        onChange={(e, { value }) => handleChange(value)}
                    />
                </Form.Field>
                <Form.Field style={{ color: 'red' }}>
                    {state?.error && translate('REQUIRED')}
                </Form.Field>
            </Form>
        </div>
    )
}


export default CopyRepElement